const contactUs = {
  formTitle: 'Связаться с нами',
  submit: 'Отправить',
  mail: 'E-mail',
  name: 'Имя',
  comment: 'Сообщение',
  sendText: 'Спасибо за Ваше обращение!',
  toForm: 'Назад'
}
export default contactUs;